import { Box, Grid2 as Grid, Typography } from '@mui/material'
import React from 'react'

import Markdown from './Markdown'
/**
 * BioCard - A component for displaying user bio with Markdown support
 * Features:
 * - Markdown rendering with iframe support
 * - Support for YouTube, Vimeo, and Bilibili embeds
 * - Compact and expanded variants
 * - Customizable styles
 *
 * @param {Object} props
 * @param {string} props.bio - The bio content in Markdown format
 * @param {string} props.variant - Display variant ('compact' or 'expanded')
 * @param {Object} props.sx - Custom styles to apply to the component
 */
const BioCard = ({ bio, variant = 'expanded' }) => {
  const isCompact = variant === 'compact'

  if (!bio) return null

  const CompactBio = () => (
    <Typography
      variant="body2"
      color="text.secondary"
      sx={{
        display: '-webkit-box',
        WebkitLineClamp: 3,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        lineHeight: 1.6,
      }}
    >
      {bio}
    </Typography>
  )

  const ExpandedBio = () => (
    <Box
      sx={{
        '& img': { maxWidth: '100%' },
        '& pre': {
          bgcolor: 'grey.100',
          p: 2,
          borderRadius: 1,
          overflow: 'auto',
        },
        '& code': {
          bgcolor: 'grey.100',
          px: 1,
          borderRadius: 0.5,
        },
        '& iframe': {
          maxWidth: '100%',
          border: '1px solid rgba(0, 0, 0, 0.12)',
          borderRadius: '4px',
        },
      }}
    >
      <Markdown>{bio}</Markdown>
    </Box>
  )

  return (
    <Grid container justifyContent="center" alignItems="center" width="100%">
      {isCompact ? CompactBio() : ExpandedBio()}
    </Grid>
  )
}

export default BioCard
